TYPED_ARRAY_CONSTRUCTOR